import { HttpRequestData, PaginationResponse, httpUtil } from '@esg/framework';
import { PaginationRequest, getEnv } from '@esg/shared';

interface GetAllBranchSubscriptionRequest extends HttpRequestData {
    readonly query: PaginationRequest & {
        startTime?: string;
        endTime?: string;
        branchId?: string;
    };
}

export interface PlanSubscription {
    readonly id: string;
    type: number;
    name: string;
    country?: string | null;
    price: number;
    durationType: number;
    durationValue: number;
    isActive: boolean;
}

export interface GetAllBranchSubscriptionResponseItem {
    readonly id: string;
    effectiveTime: string;
    expiredTime: string;
    price: number;
    name: string;
    code?: string | null;
    status: number;
    type: number;
    durationType: number;
    durationValue: number;
    planSubscription?: PlanSubscription;
    creationTime: string;
}

export const getAllBranchSubscription = httpUtil.createHttpRequestMeta<
    GetAllBranchSubscriptionRequest,
    PaginationResponse<GetAllBranchSubscriptionResponseItem>
>({
    baseUrl: () => getEnv().AGENCY_SERVER,
    path: '/api/v1/branch-subscriptions',
    method: 'GET',
    authentication: 'bearer',
});